import { Navigate, useLocation, useSearchParams } from 'react-router';
import { useAuth } from '../auth';
import { Inventory } from './Inventory';
import { Items } from './Items';

/**
 * The one list of items, as NetSuite has it. By item (the default) is one row per item with its colours under it;
 * By lot is one row per item, colour and condition, which is where stock is priced, edited in bulk and sent to BrickLink.
 * A picker only ever sees By lot.
 */
export function ItemsHub() {
  const { user } = useAuth();
  const [params] = useSearchParams();
  if (user?.role === 'picker' || params.get('view') === 'lots') return <Inventory />;
  return <Items />;
}

/** The old Inventory address: it is By lot on the Items list, with any filters kept. */
export function InventoryRedirect() {
  const { search } = useLocation();
  const p = new URLSearchParams(search);
  p.set('view', 'lots');
  return <Navigate to={`/items?${p.toString()}`} replace />;
}
